import { render } from "./Champions.vue?vue&type=template&id=6127c2cb&scoped=true"
import script from "./Champions.vue?vue&type=script&lang=ts"
export * from "./Champions.vue?vue&type=script&lang=ts"

import "./Champions.vue?vue&type=style&index=0&id=6127c2cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6127c2cb"

export default script